import {
  IAssignableExpression,
  IGraphicWidget,
  WidgetType,
} from '@framework/engine';

export const WidgetSiapDataType = 'siapData' as WidgetType.SiapData;

export interface ISiapDataWidget extends IGraphicWidget {
  type: WidgetType.SiapData;
  aooField: IAssignableExpression;
}
